import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';
import { useTranslation } from '../../common/i18n/useTranslation';
import { WbGridCol, WbGridRow, WbText } from '@workbench/react';

import MailToButton from '../MailToButton';
import { OPERATING_FLUID_MAIL_ADDRESS } from '../../utils/links';

const useStyles = makeStyles()((theme: Theme) => ({
    spacing: {
        marginBottom: theme.spacing(3),
    },
}));

function MissingPermission() {
    const translate = useTranslation();
    const { classes } = useStyles();

    return (
        <WbGridRow className={classes.spacing}>
            <WbGridCol mq1={8}>
                <WbText size="m">
                    {translate('missing_permission')}
                    <MailToButton mailto={OPERATING_FLUID_MAIL_ADDRESS} label={OPERATING_FLUID_MAIL_ADDRESS} />
                </WbText>
            </WbGridCol>
        </WbGridRow>
    );
}

export default MissingPermission;
